function isNullOrUndefined(obj) {
    return obj === undefined || obj === null;
}

export default {
    defaultIfUndefinedOrNull(obj, defaultObj) {
        return isNullOrUndefined(obj) ? defaultObj : obj;
    }
}